/**
 * Supabase often returns a fake "success" for signUp when the email already
 * exists (anti-enumeration): user object, no session, empty identities.
 * Treat that as "already registered" — never show "check your email" for it.
 */

export function isExistingAccountSignUpResponse(authData, authError) {
  const message = (authError?.message || '').toLowerCase()
  if (
    message.includes('already registered')
    || message.includes('already been registered')
    || message.includes('user already exists')
  ) {
    return true
  }

  const user = authData?.user
  if (!user) return false

  const identities = user.identities
  if (!authData?.session && Array.isArray(identities) && identities.length === 0) {
    return true
  }

  return false
}

/** True when this looks like a brand-new signup awaiting email confirmation. */
export function isGenuineNewUnconfirmedSignUp(authData) {
  const user = authData?.user
  if (!user || user.email_confirmed_at) return false
  const identities = user.identities
  return Array.isArray(identities) && identities.length > 0
}

export const EXISTING_ACCOUNT_SIGNUP_MESSAGE =
  'An account already exists for this email. Please sign in instead, or use a different email to create a new family.'

export const RESERVED_ADMIN_EMAIL_MESSAGE =
  'This email is reserved for platform administration. Use Sign in, or open /admin if you are a platform admin. Use a different email for a family account.'
